import styled from "styled-components";

export default styled.div`
  width: ${props => props.size || "100%"}
  margin: auto;
  border-radius: 3px;
  border: 1px solid #EDE7F6;
  padding: 15px;
  box-shadow: box-shadow: 4px 4px 8px 0px rgba( 0, 0, 0, 0.2 );
  @media screen and (max-width: 600px) {
    width: 100%;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Card.js